export default __webpack_public_path__ + "static/media/goods-services.13f48098.jpg";